export { default } from './Palette.js';
